import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";

import RiskAssessment from "./RiskAssessment";

type Props = {
  external_reference: string;
};

export default graphql<any, Props>(
  gql`
    query details($external_reference: ID) {
      user(external_reference: $external_reference) {
        external_reference
        customer_risk_assessment
        risk_assessment {
          risk_status
          created_at
          updated_at
          risk_completed
          risk_score
        }
        risk_assessment_history {
          risk_status
          created_at
          updated_at
          risk_completed
          risk_score
        }
      }
    }
  `,
  {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        external_reference: props.external_reference,
      },
    }),
  }
)((props) => (
  <BOGraphQLLoader data={props.data!}>
    <RiskAssessment user={props.data.user} />
  </BOGraphQLLoader>
));
